
<wire-mobile-navigation></wire-mobile-navigation>

<div class="info-container">
  <div class="info-container-wrapper">
    <div class="info-container-title">
      <span>INFO+</span>
  </div>
  <div class="info-container-content">
    <div class="info-container-content-item">
      <div class="info-container-content-item-title">Location:
        <div class="info-container-content-item-value">Knockdown Center</div>
      </div>
      <div class="info-container-content-item-title">Address:
        <div class="info-container-content-item-value">52-19 Flushing Ave, Maspeth, NY 11378</div>
      </div>
      <div class="info-container-content-item-title">Email:
        <div class="info-container-content-item-value" style="margin-left: 20px;">info&#64;wirefestival.com</div>
      </div>

    </div>
  </div>
  <a class="info-container-map-link" href="https://www.google.com/maps/place/Knockdown+Center/@40.7157764,-73.9144982,716m/data=!3m1!1e3!4m6!3m5!1s0x89c25ea2cb53d0a9:0xe6dd93729a094800!8m2!3d40.7157764!4d-73.9144982!16s%2Fg%2F1hm2tr553?entry=tts&g_ep=EgoyMDI1MDQwNy4wIPu8ASoJLDEwMjExNjQwSAFQAw%3D%3D&skid=a6668d5b-631b-41ed-aea4-f6a314da871e" target="_blank">
    <img 
    loading="lazy"
    (load)="onImageLoad($event)"
    (error)="onImageError($event)"
    class="info-container-map-link-img" src="/assets/imgs/map.png" alt="info-map">
  </a>
  </div>
   
</div>